module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa-solid fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin.html
// module id = 44
// module chunks = 0